import axios from 'axios';
import Cookies from 'js-cookie';
import { i18n } from '@/plugins/lang';
import { stringify } from 'qs';
import { goToLoginPage, logout, checkMaintainnance, checkLogin, checkUserInfo } from '@/utils';
import { API_RETURN_CODE } from '@/utils/variables';
import store from '@/store/index';

const RPInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API_URL,
  withCredentials: true,
  headers: {
    'Cache-Control': 'no-cache',
    'x-inface-api-key': process.env.VUE_APP_X_INFACE_API_KEY,
    'If-Modified-Since': '0',
  },
  cache: false,
  paramsSerializer: {
    serialize: (params) => stringify(params, { arrayFormat: 'brackets' }),
  },
});

const addAuthorizationHeader = (config) => {
  if (Cookies.get('_ifwt')) {
    config.headers.authorization = `Web ${Cookies.get('_ifwt')}`;
  }
};
const addLanguageHeader = (config) => {
  config.headers['x-rp-language'] = i18n.locale.toUpperCase();
};

RPInstance.interceptors.request.use(
  (config) => {
    addAuthorizationHeader(config);
    addLanguageHeader(config);
    return Promise.resolve(config);
  },
  (error) => {
    return Promise.reject(error);
  },
);

RPInstance.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data.code !== API_RETURN_CODE.NO_ERROR) {
      checkMaintainnance(data.code);
      checkLogin(data.code);
      checkUserInfo(data.code);
    }

    return Promise.resolve(response);
  },
  (error) => {
    const { response, config } = error;
    const { status } = response;
    if (status === 401) {
      goToLoginPage();
    }
    if (status === 500) {
      store.dispatch('modal/openModal', {
        type: 'alert',
        message: i18n.messages[i18n.locale].global.validation.commonError,
        callback: () => (window.location = `${process.env.VUE_APP_HOST}/${i18n.locale}`),
      });
    }
    // 점검중
    if (status === 503) {
      store.dispatch('modal/openModal', {
        type: 'alert',
        message: i18n.messages[i18n.locale].error.common.maintenanceDescription,
        callback: () => {
          logout();
          window.location = `${process.env.VUE_APP_HOST}/${i18n.locale}`;
        },
      });
    }

    return Promise.reject(error);
  },
);

export { RPInstance };
